import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'menu-cross',
  templateUrl: './menu-cross.component.html',
  styleUrls: ['./menu-cross.component.scss']
})
export class MenuCrossComponent implements OnInit {

  constructor(
  ) {
  }

  ngOnInit() {
  }
}
